<template>
	<div class="create-schedule">
		<el-form :model="scheduleRuleForm" :rules="scheduleRules" ref="scheduleRuleForm">
			<el-form-item prop="content">
				<div class="create-schedule-form-each">
					<img src="../../assets/common/icons/scheduleContent.png" />
					<span>内容</span>
				</div>
				<div class="create-schedule-form-each-view" v-if="useMode=='view'">
					<span>{{scheduleRuleForm.content}}</span>
				</div>
				<el-input v-else v-model="scheduleRuleForm.content" placeholder="请输入日程内容"></el-input>
			</el-form-item>
			<el-form-item prop="startTime">
				<div class="create-schedule-form-each">
					<img src="../../assets/common/icons/scheduleTime.png" />
					<span>时间</span>
				</div>
				<div class="create-schedule-form-each-view" v-if="useMode=='view'">
					<span>{{scheduleRuleForm.start_time}}</span>
					<span v-if="scheduleRuleForm.end_time">-{{scheduleRuleForm.end_time}}</span>
				</div>
				<div v-else class="create-schedule-form-time">
					<div class="create-schedule-form-time-range">
						<span class="create-schedule-form-time-range-text">开始：</span>
						<el-date-picker v-model="scheduleRuleForm.startTime" type="datetime" placeholder="请选择日期时间"
							format="yyyy-MM-dd HH:mm" default-time="09:00:00">
						</el-date-picker>
						<!-- <span class="create-schedule-form-time-range-text" style="margin: 0 0 0 20px;">结束：</span>
						<el-date-picker v-model="scheduleRuleForm.endTime" type="datetime" placeholder="请选择日期时间"
							format="yyyy-MM-dd HH:mm" default-time="18:00:00">
						</el-date-picker> -->
					</div>
					<div class="create-schedule-form-time-checkbox">
						<el-checkbox v-model="scheduleTimeHalf" @change="updateScheduleTimeType(1)">半天</el-checkbox>
						<el-checkbox v-model="scheduleTimeAll" @change="updateScheduleTimeType(2)">全天</el-checkbox>
					</div>
				</div>
			</el-form-item>
			<el-form-item prop="location">
				<div class="create-schedule-form-each">
					<img src="../../assets/common/icons/scheduleLocation.png" />
					<span>地点</span>
				</div>
				<div class="create-schedule-form-each-view" v-if="useMode=='view'">
					<span>{{scheduleRuleForm.location}}</span>
				</div>
				<el-input v-else v-model="scheduleRuleForm.location" placeholder="待添加具体地点"></el-input>
			</el-form-item>
			<el-form-item prop="remark" v-if="(useMode=='view' && scheduleRuleForm.remark) || useMode!='view'">
				<div class="create-schedule-form-each">
					<img src="../../assets/common/icons/scheduleRemark.png" />
					<span>备注</span>
				</div>
				<div class="create-schedule-form-each-view" v-if="useMode=='view'">
					<span>{{scheduleRuleForm.remark}}</span>
				</div>
				<el-input v-else v-model="scheduleRuleForm.remark" placeholder="添加备注"></el-input>
			</el-form-item>
			<el-form-item prop="leaderList">
				<div class="create-schedule-form-each">
					<img src="../../assets/common/icons/scheduleLeaders.png" />
					<span>校领导</span>
					<div class="create-schedule-form-each-leader-number"
						v-if="scheduleRuleForm && scheduleRuleForm.leaderList && scheduleRuleForm.leaderList.length > 0">
						<span>·</span>
						<span>{{scheduleRuleForm.leaderList.length}}</span>
					</div>
				</div>
				<div class="create-schedule-form-leaders">
					<div class="create-schedule-form-leaders-list">
						<div class="create-schedule-form-leaders-list-each"
							v-for="(item, index) in scheduleRuleForm.leaderList" :key="index">
							<span>{{item.name}}</span>
							<img v-if="item.isReminded && useMode!='edit'"
								src="../../assets/common/icons/scheduleRemind.png" />
							<el-switch v-model="item.isReminded" v-if="useMode=='edit'"
								@change="changeRemindedSwitch($event, index)">
							</el-switch>
						</div>
					</div>
					<el-popover placement="top-start" width="240" trigger="click" ref="leaderListPopover">
						<div class="create-schedule-form-leaders-select">
							<!-- <el-input v-model="leaderNameInput" placeholder="搜索"></el-input> -->
							<div class="leaders-select-list">
								<div class="leaders-select-list-each" v-for="(item, index) in memberList" :key="index">
									<div class="leaders-select-list-each-info">
										<el-checkbox v-model="item.isJoined"
											@change="addLeaderToSchedule($event, index)"></el-checkbox>
										<img src="../../assets/common/userHeadImg_Default.png" />
										<span>{{item.name}}</span>
									</div>
									<div class="leaders-select-list-each-remindBtn"
										@click="remindLeaderSchedule(index)">
										<img v-if="item.isReminded"
											src="../../assets/common/icons/scheduleRemind.png" />
										<img v-else src="../../assets/common/icons/scheduleNotRemind.png" />
									</div>
								</div>
							</div>
							<el-button type="primary" @click="updateScheduleLeaderList">确定</el-button>
						</div>
						<i v-if="useMode=='create'" class="el-icon-circle-plus" slot="reference"
							style="cursor: pointer;"></i>
					</el-popover>
				</div>
			</el-form-item>
			<el-form-item prop="files" v-if="useMode!='view'">
				<div class="create-schedule-form-each">
					<img src="../../assets/common/icons/uploadAttachments.png" />
					<span>上传附件</span>
				</div>
				<el-upload class="create-schedule-form-each-upload" drag :action="uploadAction" multiple
					:on-success="uploadFiles" :on-remove="deleteFiles" :before-upload="beforeUploadFiles"
					:on-error="uploadFilesError" :file-list="uploadFilesList">
					<img src="../../assets/common/icons/uploadFile.png" />
					<div class="el-upload__text"><em>点击上传</em>，或将文件拖拽到此处</div>
					<div class="el-upload__text">(最大不超过512MB)</div>
				</el-upload>
			</el-form-item>
			<el-form-item prop="files" v-if="useMode=='view' && uploadFilesList.length > 0">
				<div class="create-schedule-form-each">
					<img src="../../assets/common/icons/uploadAttachments.png" />
					<span>附件列表</span>
				</div>
				<div class="file-list">
					<div class="file-list-each" v-for="(item, index) in uploadFilesList" :key="index">
						<div class="file-list-each-info">
							<img src="../../assets/common/icons/uploadFile.png" />
							<span>{{item.name}}</span>
						</div>
						<div class="file-list-each-btns">
							<div class="file-list-btns-each" @click="downloadFile(item)">
								<span>下载</span>
							</div>
						</div>
					</div>
				</div>
			</el-form-item>
			<el-form-item prop="createUser" v-if="useMode=='view'">
				<div class="create-schedule-form-each">
					<img src="../../assets/common/icons/editUser.png" />
					<span>创建人</span>
				</div>
				<div class="create-schedule-form-each-view">
					<span>{{scheduleInfo.createUser}}</span>
				</div>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button v-if="useMode=='create'" type="primary" @click="confirmEditSchedule(1)"
				:loading="confirmEditLoading">完成创建</el-button>
			<el-button v-if="useMode=='edit'" type="success" @click="confirmEditSchedule(2)"
				:loading="confirmEditLoading">完成编辑</el-button>
			<el-popover placement="top" width="400" trigger="click" ref="deletePopover"
				popper-class="schedule-list-table-btns-popover">
				<el-button v-if="useMode=='edit'" type="danger" slot="reference">删除日程</el-button>
				<tipsModal :modalTitle="'温馨提示'" :modalContent="'确定删除此项日程？'" @hideModal="hideModal"
					@modalConfirm="modalConfirm">
				</tipsModal>
			</el-popover>
		</div>
	</div>
</template>

<script>
	import tipsModal from '../tools/TipsModal.vue';
	export default {
		components: {
			tipsModal
		},
		props: {
			memberList: { //人员列表
				type: Array,
				default: []
			},
			useMode: { //使用模式:create-创建，edit-编辑，view-查看
				type: String,
				default: 'create'
			},
			scheduleInfo: { //待编辑/查看的日程信息
				type: Object,
				default: () => {
					return {};
				}
			},
			viewUserId: { //查看的用户Id
				type: Number,
				default: -1
			}
		},
		data() {
			return {
				userId: '', //当前登录用户
				leaderNameInput: '', //领导列表按姓名搜索
				confirmEditLoading: false, //创建日程按钮加载状态
				scheduleTimeHalf: true, //日程时间-半天
				scheduleTimeAll: false, //日程时间-全天
				uploadAction: '', //文件上传路径
				uploadFilesList: [], //上传的文件列表
				userInfo: '', //用户信息
				scheduleRuleForm: {
					content: '',
					startTime: '',
					endTime: '',
					location: '',
					remark: '',
					leaderList: []
				}, //日程创建表单规则
				scheduleRules: {
					content: [{
						required: true,
						message: '请输入内容',
						trigger: 'blur'
					}],
					startTime: [{
						required: true,
						type: 'date',
						message: '请选择开始时间',
						trigger: 'change'
					}],
					endTime: [{
						required: false,
						type: 'date',
						message: '请选择结束时间',
						trigger: 'change'
					}],
					location: [{
						required: true,
						message: '请输入具体地点',
						trigger: 'blur'
					}],
					remark: [{
						required: false,
						message: '请输入备注',
						trigger: 'blur'
					}],
					leaderList: [{
						required: false,
						message: '请至少选择一个校领导',
						trigger: 'change'
					}]
				}
			}
		},
		mounted() {
			let that = this;
			that.$nextTick(() => {
				let userInfo = JSON.parse(localStorage.getItem('userInfo'));
				that.userInfo = userInfo;
				that.userId = userInfo.id;
				that.uploadAction = that.$api.BASE_URL + "/suda/uploadFile";
				that.assembleLeaderList();
			})
		},
		watch: {
			scheduleInfo: {
				handler(newScheduleInfo, oldScheduleInfo) {
					let that = this;
					console.log(newScheduleInfo)
					if (newScheduleInfo.scheduleId) {
						that.loadScheduleInfo();
					}
				},
				immediate: true,
				deep: true
			}
		},
		methods: {
			//组装领导列表初始数据
			assembleLeaderList() {
				let that = this;
				that.memberList.forEach((item, index) => {
					item.isJoined = false;
					item.isReminded = false;
				})
			},
			//编辑模式下加载填写的日程信息
			loadScheduleInfo() {
				let that = this;
				console.log(that.scheduleInfo)
				that.scheduleRuleForm = JSON.parse(JSON.stringify(that.scheduleInfo));
				that.scheduleRuleForm.startTime = that.scheduleInfo.startTime ? new Date(that.scheduleInfo.startTime) : '';
				that.scheduleRuleForm.start_time = that.scheduleInfo.startTime ? that.$utils.fmtDate(new Date(that
					.scheduleInfo.startTime), "yyyy-MM-dd hh:mm") : '';
				that.scheduleRuleForm.endTime = that.scheduleInfo.endTime ? new Date(that.scheduleInfo.endTime) : '';
				that.scheduleRuleForm.end_time = that.scheduleInfo.endTime ? that.$utils.fmtDate(new Date(that.scheduleInfo
					.endTime), "yyyy-MM-dd hh:mm") : '';
				that.scheduleRuleForm.leaderList = that.scheduleInfo.school_leaders;
				if (that.scheduleInfo.files) {
					that.uploadFilesList = JSON.parse(that.scheduleInfo.files);
				} else {
					that.uploadFilesList = [];
				}
				that.memberList.forEach((memberItem, memberIndex) => {
					memberItem.isJoined = false;
					memberItem.isReminded = false;
				})
				if (that.scheduleRuleForm && that.scheduleRuleForm.leaderList && that.scheduleRuleForm.leaderList.length >
					0) {
					that.scheduleRuleForm.leaderList.forEach((item, index) => {
						if (item.isNoticed == 1) {
							item.isReminded = true;
						} else if (item.isNoticed == 0) {
							item.isReminded = false;
						}
						that.memberList.forEach((memberItem, memberIndex) => {
							if (item.id == memberItem.userId) {
								memberItem.isJoined = true;
								if (item.isReminded) {
									memberItem.isReminded = true;
								}
							}
						})
					})
				}
			},
			//点击切换日程时间-半天/全天的选中状态
			updateScheduleTimeType(flag) {
				let that = this;
				if (flag == 1) {
					that.scheduleTimeHalf = true;
					that.scheduleTimeAll = false;
				} else if (flag == 2) {
					that.scheduleTimeHalf = false;
					that.scheduleTimeAll = true;
				}
			},
			//点击将当前领导加入日程
			addLeaderToSchedule(e, flag) {
				let that = this;
				if (e) {
					that.memberList[flag].isJoined = true;
				} else {
					that.memberList[flag].isJoined = false;
					that.memberList[flag].isReminded = false;
				}
				that.$forceUpdate();
			},
			//点击提醒当前领导日程安排
			remindLeaderSchedule(flag) {
				let that = this;
				that.memberList[flag].isReminded = !that.memberList[flag].isReminded;
				if (that.memberList[flag].isReminded) {
					that.addLeaderToSchedule(true, flag);
				}
				that.$forceUpdate();
			},
			//点击更新参加日程的领导列表
			updateScheduleLeaderList() {
				let that = this;
				that.scheduleRuleForm.leaderList = [];
				that.memberList.forEach((item, index) => {
					if (item.isJoined) {
						if (that.scheduleRuleForm.leaderList.length == 0) {
							that.scheduleRuleForm.leaderList.push(item);
						} else {
							let hasAdded = false;
							that.scheduleRuleForm.leaderList.forEach((leaderItem, leaderIndex) => {
								if (item.id == leaderItem.id) {
									hasAdded = true;
								}
							})
							if (!hasAdded) {
								that.scheduleRuleForm.leaderList.push(item);
							}
						}
					}
				})
				that.$refs['leaderListPopover'].doClose();
			},
			//点击创建日程
			confirmEditSchedule(flag) {
				let that = this;
				that.confirmEditLoading = true;
				that.$refs["scheduleRuleForm"].validate((valid) => {
					if (valid) {
						that.scheduleRuleForm.involves = [];
						that.scheduleRuleForm.notices = [];
						that.scheduleRuleForm.createUser = Number(that.userId);
						that.scheduleRuleForm.leaderList.forEach((item, index) => {
							if (item.isJoined) {
								that.scheduleRuleForm.involves.push(item.id);
							}
							if (item.isReminded) {
								that.scheduleRuleForm.notices.push(item.id);
							}
						})
						if (!that.scheduleRuleForm.endTime) {
							let date = new Date(that.scheduleRuleForm.startTime);
							if (that.scheduleRuleForm.startTime.getHours() < 12) {
								if (that.scheduleTimeHalf) {
									date.setHours(12, 0, 0);
								} else {
									date.setHours(18, 0, 0);
								}
							} else {
								date.setHours(18, 0, 0);
							}
							that.scheduleRuleForm.endTime = date;
						}
						let params = that.scheduleRuleForm;
						if (that.uploadFilesList.length > 0) {
							params.files = JSON.stringify(that.uploadFilesList);
						}
						if (flag == 1) {
							// console.log(params)
							params.creator = that.userId;
							that.$api.setSchedule(params).then(res => {
								console.log(res)
								that.confirmEditLoading = false;
								if (res.code == 1) {
									that.$emit("confirmEditSchedule");
								}
							}).catch(err => {
								console.log(err)
								that.confirmEditLoading = false;
							})
						} else if (flag == 2) {
							params.scheduleId = that.scheduleInfo.scheduleId;
							params.uuid = that.scheduleInfo.uuid;
							let updateScheduleFun;
							if (that.userId == that.viewUserId && that.userInfo.role != 1 && that.userInfo.role !=
								2) {
								updateScheduleFun = that.$api.updateSchedule(params);
							} else {
								params.userId = that.viewUserId;
								params.content = JSON.stringify(that.scheduleRuleForm);
								updateScheduleFun = that.$api.setRepresentation(params);
							}
							// console.log(params)
							updateScheduleFun.then(res => {
								console.log(res)
								that.confirmEditLoading = false;
								if (res.code == 1) {
									that.$emit("confirmEditSchedule");
								}
							}).catch(err => {
								console.log(err)
								that.confirmEditLoading = false;
							})
						}
					} else {
						that.confirmEditLoading = false;
						return false;
					}
				});
			},
			//点击删除日程
			deleteSchedule() {
				let that = this;
				let params = {
					uuid: that.scheduleInfo.uuid,
					scheduleId: that.scheduleInfo.scheduleId
				};
				let deleteScheduleFun;
				if (that.userId == that.viewUserId && that.userInfo.role != 1 && that.userInfo.role != 2) {
					deleteScheduleFun = that.$api.deleteSchedule(params);
				} else {
					if (that.scheduleInfo.representationId || that.scheduleInfo.representationId == 0) {
						params.id = that.scheduleInfo.representationId;
					} else {
						params.id = -1;
					}
					params.userId = that.viewUserId;
					deleteScheduleFun = that.$api.deleteRepresentation(params);
				}
				// console.log(params)
				deleteScheduleFun.then(res => {
					console.log(res)
					if (res.code == 1) {
						that.$emit("confirmEditSchedule");
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//点击隐藏删除弹窗提示
			hideModal() {
				let that = this;
				that.$refs['deletePopover'].doClose();
			},
			//点击确认执行模态框的操作
			modalConfirm() {
				let that = this;
				that.$refs['deletePopover'].doClose();
				that.deleteSchedule();
			},
			//上传文件成功回调
			uploadFiles(e) {
				let that = this;
				that.confirmEditLoading = false;
				that.uploadFilesList.push(e);
			},
			//删除文件成功回调
			deleteFiles(e) {
				let that = this;
				that.uploadFilesList.forEach((item, index) => {
					if (item.uuid == e.uuid) {
						that.uploadFilesList.splice(index, 1);
					}
				})
			},
			//上传文件失败时回调
			uploadFilesError(e) {
				let that = this;
				let error = JSON.parse(e.message);
				that.confirmEditLoading = false;
				that.$message.error(error.error + ":" + error.message);
			},
			//上传文件前钩子
			beforeUploadFiles(e) {
				let that = this;
				that.confirmEditLoading = true;
			},
			//点击下载上传的文件
			downloadFile(file) {
				let that = this;
				let params = {
					filePath: file.url
				};
				that.$api.getFile(params).then(res => {
					// console.log(res)
					const url = window.URL.createObjectURL(new Blob([res]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', file.name);
					document.body.appendChild(link);
					link.click();
				}).catch(err => {
					console.log(err)
				})
			},
			//点击修改提醒开关
			changeRemindedSwitch(e, index) {
				let that = this;
				that.scheduleRuleForm.leaderList[index].isReminded = e;
				that.$forceUpdate();
			}
		}
	}
</script>

<style lang="scss">
	.create-schedule {
		.dialog-footer {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
		}

		.el-button--primary {
			background: #1A66FE;
			font-weight: 400;
			color: #FCFCFC;
		}

		.el-input__inner {
			border-color: #ACABA8;
			font-weight: 400;
			color: #666666;
		}

		.el-input__inner::placeholder {
			color: #666666;
		}

		.el-checkbox__label {
			font-weight: 400;
			color: #333333;
		}

		.el-checkbox__input.is-checked .el-checkbox__inner,
		.el-checkbox__input.is-indeterminate .el-checkbox__inner {
			background-color: #2ACC72;
			border-color: #2ACC72;
		}

		.el-checkbox__input.is-checked+.el-checkbox__label {
			color: #333;
		}

		.el-form-item__content {
			font-size: 35px;
			color: #1A66FE;
		}

		.el-button--success {
			background-color: #3F79F7;
			border-color: #3F79F7;
		}

		.el-button--success,
		.el-button--danger {
			font-weight: 400;
			color: #FCFCFC;
		}

		.create-schedule-form-each {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-start;

			img {}

			span {
				font-weight: 400;
				color: #333333;
			}

			.create-schedule-form-each-leader-number {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: flex-start;

				span {
					font-weight: bold;
					color: #FE012B;
				}
			}
		}

		.create-schedule-form-each-view {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-start;

			span {
				font-weight: 400;
				color: #333333;
			}
		}

		.create-schedule-form-time {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-between;

			.create-schedule-form-time-checkbox {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: flex-start;
			}

			.create-schedule-form-time-range {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: flex-end;

				.create-schedule-form-time-range-text {
					font-weight: 400;
					color: #333333;
				}
			}
		}

		.create-schedule-form-leaders {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-start;

			.create-schedule-form-leaders-list {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: flex-start;

				.create-schedule-form-leaders-list-each {
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: center;
					position: relative;

					span {
						font-weight: 400;
						color: #333333;
					}

					img {
						position: absolute;
						top: 0;
						right: -25%;
					}
				}
			}
		}

		.create-schedule-form-each-upload {
			img {}
		}

		.file-list {
			.file-list-each {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;

				.file-list-each-info {
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: flex-start;
					width: 100%;

					img {
						width: 30px;
						height: 30px;
						margin: 0 16px 0 0;
					}

					span {
						font-weight: 400;
						color: #333333;
						width: 100%;
					}
				}

				.file-list-each-btns {
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: flex-end;
					flex-shrink: 0;

					.file-list-btns-each {
						cursor: pointer;

						span {
							font-weight: 400;
						}
					}
				}
			}
		}
	}

	.create-schedule-form-leaders-select {
		.leaders-select-list {
			overflow: scroll;

			.leaders-select-list-each {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;

				.leaders-select-list-each-info {
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: flex-start;
				}

				.leaders-select-list-each-remindBtn {
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: flex-end;
				}
			}
		}

		.el-button--primary {
			width: 100%;
		}
	}

	.schedule-list-table-btns-popover {
		padding: 0;
		border: 0;
		overflow: hidden;
	}

	@media screen and (min-width: 1024px) {
		.create-schedule {
			padding: 0 10px;

			.el-switch {
				margin: 0 0 0 12px;
			}

			.el-button--primary {
				border-radius: 13px;
				width: 242px;
				font-size: 16px;
			}

			.el-input__inner {
				font-size: 14px;
				height: 31px;
			}

			.el-checkbox__label {
				font-size: 14px;
				line-height: 24px;
			}

			.el-checkbox__inner {
				width: 21px;
				height: 21px;
				border-radius: 4px;
			}

			.el-checkbox__inner::after {
				border: 2px solid #FFF;
				border-left: 0;
				border-top: 0;
				height: 11px;
				left: 6px;
				top: 1px;
				width: 5px;
			}

			.el-date-editor.el-input,
			.el-date-editor.el-input__inner {
				width: 172px;
			}

			.el-input__icon {
				font-size: 12px;
				line-height: 30px;
			}

			.el-upload-dragger {
				width: 215px;
				height: 100px;
			}

			.el-button--success,
			.el-button--danger {
				width: 171px;
				border-radius: 6px;
				margin: 0 14px;
				font-size: 18px;
			}

			.el-form-item__content {
				line-height: 1;
			}

			.create-schedule-form-each {
				margin: 0;

				img {
					width: 25px;
					height: 25px;
				}

				span {
					font-size: 14px;
					margin: 0 0 0 12px;
				}

				.create-schedule-form-each-leader-number {
					span {
						margin: 0 0 0 3px;
						font-size: 18px;
					}

					span:last-child {
						margin: 0 0 0 3px;
					}
				}
			}

			.create-schedule-form-each-view {
				span {
					font-size: 14px;
				}
			}

			.create-schedule-form-time {
				padding: 0 0 0 4px;

				.create-schedule-form-time-checkbox {
					height: 50px;
					margin: 0 20px 0 0;
				}

				.create-schedule-form-time-range {
					.create-schedule-form-time-range-text {
						font-size: 14px;
						line-height: 24px;
					}
				}
			}

			.create-schedule-form-leaders {
				.create-schedule-form-leaders-list {
					.create-schedule-form-leaders-list-each {
						margin: 0 34px 0 0;

						span {
							font-size: 14px;
						}

						img {
							width: 18px;
							height: 18px;
						}
					}
				}
			}

			.create-schedule-form-each-upload {
				img {
					width: 26px;
					height: 26px;
					margin: 13px 0 0;
				}
			}

			.file-list {
				.file-list-each {

					.file-list-each-info {

						img {}

						span {
							font-size: 14px;
						}
					}

					.file-list-each-btns {

						.file-list-btns-each {
							span {
								font-size: 14px;
							}
						}
					}
				}
			}
		}

		.create-schedule-form-leaders-select {
			.leaders-select-list {
				max-height: 170px;
				margin: 20px 0;

				.leaders-select-list-each {
					margin: 0 0 10px;

					.leaders-select-list-each-info {
						img {
							width: 18px;
							height: 18px;
							margin: 0 4px;
						}
					}

					.leaders-select-list-each-remindBtn {
						img {
							width: 16px;
							height: 16px;
							margin: 0 12px 0 0;
						}
					}
				}
			}
		}

		.schedule-list-table-btns-popover {
			border-radius: 11px;
		}
	}

	@media screen and (min-width: 1280px) {}

	@media screen and (min-width: 1366px) {}

	@media screen and (min-width: 1440px) {}

	@media screen and (min-width: 1680px) {
		.create-schedule {
			padding: 0 10px;

			.el-switch {
				margin: 0 0 0 20px;
			}

			.el-button--primary {
				border-radius: 21px;
				width: 400px;
				height: 60px;
				font-size: 27px;
			}

			.el-input__inner {
				font-size: 21px;
				height: 50px;
			}

			.el-checkbox__label {
				font-size: 21px;
				line-height: 50px;
			}

			.el-checkbox__inner {
				width: 35px;
				height: 35px;
				border-radius: 7px;
			}

			.el-checkbox__inner::after {
				border: 3px solid #FFF;
				border-left: 0;
				border-top: 0;
				height: 20px;
				left: 9px;
				top: 1px;
				width: 12px;
			}

			.el-date-editor.el-input,
			.el-date-editor.el-input__inner {
				width: 244px;
			}

			.el-input__icon {
				font-size: 20px;
				line-height: 50px;
			}

			.el-upload-dragger {
				width: 326px;
				height: 160px;
			}

			.el-button--success,
			.el-button--danger {
				width: 280px;
				height: 60px;
				border-radius: 11px;
				margin: 0 25px;
				font-size: 28px;
			}

			.el-form-item__content {
				line-height: 40px;
			}

			.create-schedule-form-each {
				margin: 0 0 12px;

				img {
					width: 40px;
					height: 40px;
				}

				span {
					font-size: 23px;
					margin: 0 0 0 20px;
				}

				.create-schedule-form-each-leader-number {
					span {
						margin: 0 0 0 5px;
						font-size: 30px;
					}

					span:last-child {
						margin: 0 0 0 5px;
					}
				}
			}

			.create-schedule-form-each-view {
				span {
					font-size: 23px;
				}
			}

			.create-schedule-form-time {
				padding: 0 0 0 4px;

				.create-schedule-form-time-checkbox {
					height: 50px;
					margin: 0 20px 0 0;
				}

				.create-schedule-form-time-range {
					.create-schedule-form-time-range-text {
						font-size: 21px;
						line-height: 50px;
					}
				}
			}

			.create-schedule-form-leaders {
				.create-schedule-form-leaders-list {
					.create-schedule-form-leaders-list-each {
						margin: 0 34px 0 0;

						span {
							font-size: 23px;
						}

						img {
							width: 22px;
							height: 22px;
						}
					}
				}
			}

			.create-schedule-form-each-upload {
				img {
					width: 42px;
					height: 42px;
					margin: 18px 0 0;
				}
			}

			.file-list {
				.file-list-each {

					.file-list-each-info {

						img {}

						span {
							font-size: 23px;
						}
					}

					.file-list-each-btns {

						.file-list-btns-each {
							span {
								font-size: 23px;
							}
						}
					}
				}
			}
		}

		.create-schedule-form-leaders-select {
			.leaders-select-list {
				max-height: 170px;
				margin: 20px 0;

				.leaders-select-list-each {
					margin: 0 0 10px;

					.leaders-select-list-each-info {
						img {
							width: 30px;
							height: 30px;
							margin: 0 8px;
						}
					}

					.leaders-select-list-each-remindBtn {
						img {
							width: 30px;
							height: 30px;
							margin: 0 20px 0 0;
						}
					}
				}
			}
		}

		.schedule-list-table-btns-popover {
			border-radius: 11px;
		}
	}

	@media screen and (min-width: 1920px) {}
</style>